"use client";
import { useCallback, useState, useEffect, useRef } from "react";

import StyledButton from "@stadium/ui/src/components/button/styled-button";
import MultiLevelMenu from "@components/store/multi-level-menu";

import styles from "./main.module.scss";

const HeaderMenu = () => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);

  const checkOverflow = useCallback(() => {
    const el = scrollRef.current;
    if (!el) return;
    setShowLeftArrow(el.scrollLeft > 5);
    setShowRightArrow(el.scrollLeft + el.clientWidth < el.scrollWidth - 5);
  }, []);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    checkOverflow();
    el.addEventListener("scroll", checkOverflow, { passive: true });
    const observer = new ResizeObserver(checkOverflow);
    observer.observe(el);
    return () => {
      el.removeEventListener("scroll", checkOverflow);
      observer.disconnect();
    };
  }, [checkOverflow]);

  const scrollLeft = useCallback(() => {
    scrollRef.current?.scrollBy({ left: -200, behavior: "smooth" });
  }, []);

  const scrollRight = useCallback(() => {
    scrollRef.current?.scrollBy({ left: 200, behavior: "smooth" });
  }, []);

  return (
    <div className={styles.swagmagicMenuBar}>
      {showLeftArrow && (
        <StyledButton
          styleType="icon-btn"
          className={styles.swagmagicMenuArrowLeft}
          onClick={scrollLeft}
          aria-label="Scroll left"
        >
          <span className={styles.swagmagicMenuArrowIconLeft} />
        </StyledButton>
      )}
      <div className={styles.swagmagicMenuScroll} ref={scrollRef}>
        <MultiLevelMenu scrollable />
      </div>
      {showRightArrow && (
        <StyledButton
          styleType="icon-btn"
          className={styles.swagmagicMenuArrow}
          onClick={scrollRight}
          aria-label="Scroll right"
        >
          <span className={styles.swagmagicMenuArrowIcon} />
        </StyledButton>
      )}
    </div>
  );
};

export default HeaderMenu;
